import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

import { invalidateJobQueries } from "components/job/queries";
import { createBucketConfig, updateBucketConfig } from "./api";
import { formatDateForAPI } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  return {
    ...Object.fromEntries(
      Object.entries(values).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };
}

export function useCreateBucketConfig() {
  return useMutation({
    mutationFn: async ({ jobId, values }) => {
      const payload = buildPayload(values);
      return await createBucketConfig({ jobId, values: payload });
    },
    onSuccess: () => {
      toast.success("Config created successfully");
      invalidateJobQueries();
    },
    onError: (err) => {
      toast.error(err.message || "Failed to create config");
      console.error(err);
    },
  });
}

export function useUpdateBucketConfig() {
  return useMutation({
    mutationFn: async ({ id, values }) => {
      const payload = buildPayload(values);
      return await updateBucketConfig({ id, values: payload });
    },
    onSuccess: () => {
      toast.success("Config updated successfully");
      invalidateJobQueries();
    },
    onError: (err) => {
      toast.error(err.message || "Failed to update config");
      console.error(err);
    },
  });
}
